import { Stack, Tab, TabList, TabPanel, TabPanels, Tabs, VStack } from "@chakra-ui/react";
import LogOutOnly from "../../../components/Auth/LogOutOnly";
import { colors } from "../../../styles";
import Id from "./Id";
import Password from "./Password";

export default function Find() {

    /* 렌더링 */

    return (
        <LogOutOnly>
            <VStack 
                justifyContent={"center"} 
                alignItems={"center"} 
                padding={10}
                height={"100vh"}
            >
                <Stack  
                    width={{
                        base:"100%",
                        sm:"90%",
                        md:"60%",
                        lg:"40%",
                        xl:"40%"
                    }} 
                >
                    <Tabs isFitted>
                        <TabList>
                            <Tab _selected={{color: colors.blue, fontWeight: 700, borderBottom: `2px solid ${colors.blue}`}} padding={3}>아이디(이메일)찾기</Tab>
                            <Tab _selected={{color: colors.blue, fontWeight: 700, borderBottom: `2px solid ${colors.blue}`}} padding={3}>비밀번호 재설정</Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel>
                                <Id />
                            </TabPanel>
                            <TabPanel>
                                <Password />
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Stack>
            </VStack>
        </LogOutOnly>
    );
}